export default __webpack_public_path__ + "static/mid5b-62673baae09e63aedf38a31d9f0b4f66.png";